import React, { FC } from 'react';

import { AggregatedAlertDetails } from '@ariksa/notification/api';
import { Box } from '@chakra-ui/react';

import { Drawer } from 'components/Overlay';
import { FindingDrawerContent } from 'containers/Findings/AlertDrawer/Components/Aggregated/FindingDrawerContent';
import { FindingDrawerHeader } from 'containers/Findings/AlertDrawer/Components/Aggregated/FindingDrawerHeader';
import { alertDrawerSaga } from 'containers/Findings/AlertDrawer/saga';
import { reducer, sliceKey } from 'containers/Findings/AlertDrawer/slice';
import { useInjector } from 'utils/inject';

interface IFindingDrawer {
  finding: AggregatedAlertDetails;
  isOpen: boolean;

  onClose();

  tabIndex: number;
  setTabIndex: (value: number) => void;
}

export const FindingDrawer: FC<IFindingDrawer> = props => {
  useInjector(sliceKey, reducer, alertDrawerSaga);
  const { finding, isOpen, onClose, tabIndex, setTabIndex } = props;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      header={<FindingDrawerHeader finding={finding} />}
      body={
        <Box h="full" w="full">
          <FindingDrawerContent
            alert={finding}
            tabIndex={tabIndex}
            setTabIndex={setTabIndex}
          />
        </Box>
      }
      closeButton
      styles={{
        content: { maxW: '1640px' },
      }}
    />
  );
};
